/**
 * Browser detection utilities for handling browser-specific behaviors
 */

/**
 * Detects if the current browser is Safari on iOS (iPhone/iPad)
 * This is specifically needed for handling Keycloak authentication issues
 * where Safari doesn't support Session Status iframe
 */
export function isMobileSafari(): boolean {
    const userAgent = navigator.userAgent || "";

    // Check for iOS devices
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    // Check for Safari (but not Chrome on iOS which has different behavior)
    const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);

    return isIOS && isSafari;
}

/**
 * Detects if the current browser is any mobile browser
 * Useful for general mobile-specific behaviors
 */
export function isMobile(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**
 * Detects if the current browser supports Session Status iframe
 * Used to determine if we can use silent SSO checks
 */
export function supportsSessionStatusIframe(): boolean {
    // Mobile Safari and some other browsers don't support this
    return !isMobileSafari();
}
